"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAP_QUERY = exports.RASTERS_FRAGMENT = exports.MAP_FIRMS_FRAGMENT = exports.ACCOUNT_MAP_FRAGMENT = void 0;
const client_1 = require("@apollo/client");
exports.ACCOUNT_MAP_FRAGMENT = (0, client_1.gql) `
  fragment AccountMapFragment on Account {
    defaultBaseMap {
      mapboxStyle
    }
    bounds
  }
`;
exports.MAP_FIRMS_FRAGMENT = (0, client_1.gql) `
  fragment MapFIRMsFragment on Account {
    firms {
      id
      name
      datum
      isDefault
      components {
        limwas {
          hasGeometries
          visibleByDefault
        }
        panels {
          hasGeometries
          visibleByDefault
        }
        baseFloodElevations {
          hasGeometries
          visibleByDefault
        }
        crossSections {
          hasGeometries
          visibleByDefault
          hasElevations
        }
        profileBaselines {
          hasGeometries
          visibleByDefault
        }
      }
      tileset {
        id
        mapboxId
      }
    }
    baseMaps {
      name
      id
      isDefault
      mapboxStyle
    }
  }
`;
exports.RASTERS_FRAGMENT = (0, client_1.gql) `
  fragment RasterFIRMsFragment on Account {
    rasters {
      id
      layerName
      layerSection
      createdAt
      bandMappings {
        bandNumber
        measurementUnit
        measurementName
      }
    }
  }
`;
exports.MAP_QUERY = (0, client_1.gql) `
  query MapsForAccount {
    account {
      id
      name
      accountDocumentTypes {
        id
        name
        color
        allowedMimeTypes
        attachments {
          type
          customMapIds
        }
        order
        documentType {
          id
          name
        }
      }
      accountPropertyWarningDefinitions {
        id
        title
        message
        group
        severity
        isActive
        isCustom
        isPublic
        isSensitive
      }
      savedViews {
        id
        name
        query
      }
      ...RasterFIRMsFragment
      ...MapFIRMsFragment
      ...AccountMapFragment
    }
  }
  ${exports.RASTERS_FRAGMENT}
  ${exports.MAP_FIRMS_FRAGMENT}
  ${exports.ACCOUNT_MAP_FRAGMENT}
`;
//# sourceMappingURL=data:application/json;base64,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